/**
 * Pixelgipfel — header interactions.
 * - Megamenu open/close (click + Escape + outside-click)
 * - Language dropdown
 * - Responsive overflow/mobile drawer with focus management
 * - Cart badge updates on cart:updated custom event
 */
(function () {
  'use strict';

  function once(el, key, fn) {
    if (!el || el.dataset[key] === '1') return;
    el.dataset[key] = '1';
    fn();
  }

  function closeAllMegas(except) {
    document.querySelectorAll('[data-pg-mega-parent][data-open="true"]').forEach(function (parent) {
      if (parent === except) return;
      parent.setAttribute('data-open', 'false');
      const btn = parent.querySelector('[data-pg-mega-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAllLangs(except) {
    document.querySelectorAll('[data-pg-lang][data-open="true"]').forEach(function (wrap) {
      if (wrap === except) return;
      wrap.setAttribute('data-open', 'false');
      const btn = wrap.querySelector('[data-pg-lang-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function wireMega() {
    document.querySelectorAll('[data-pg-mega-parent]').forEach(function (parent) {
      once(parent, 'pgMegaWired', function () {
        const toggle = parent.querySelector('[data-pg-mega-toggle]');
        if (!toggle) return;
        parent.setAttribute('data-open', 'false');
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = parent.getAttribute('data-open') === 'true';
          closeAllMegas(parent);
          parent.setAttribute('data-open', isOpen ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
        toggle.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowDown') return;
          e.preventDefault();
          closeAllMegas(parent);
          parent.setAttribute('data-open', 'true');
          toggle.setAttribute('aria-expanded', 'true');
          const firstLink = parent.querySelector('.pg-mega a[href]');
          if (firstLink) firstLink.focus();
        });
      });
    });
  }

  // Taxonomie-Mega: Kategorie-Rail schaltet Panels (hover/focus)
  function wireMegaRail() {
    document.querySelectorAll('[data-pg-mega-tax]').forEach(function (mega) {
      once(mega, 'pgMegaTaxWired', function () {
        const rails = mega.querySelectorAll('[data-pg-mega-cat]');
        const panels = mega.querySelectorAll('[data-pg-mega-panel]');
        function activate(idx) {
          rails.forEach(function (r) {
            const on = r.getAttribute('data-pg-mega-cat') === idx;
            r.classList.toggle('is-active', on);
            if (on) { r.setAttribute('aria-current', 'true'); } else { r.removeAttribute('aria-current'); }
          });
          panels.forEach(function (p) {
            p.hidden = p.getAttribute('data-pg-mega-panel') !== idx;
          });
        }
        rails.forEach(function (r) {
          const idx = r.getAttribute('data-pg-mega-cat');
          r.addEventListener('mouseenter', function () { activate(idx); });
          r.addEventListener('focus', function () { activate(idx); });
          r.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowRight') return;
            const panel = Array.prototype.find.call(panels, function (p) { return p.getAttribute('data-pg-mega-panel') === idx; });
            const link = panel && panel.querySelector('a[href]');
            if (link) { e.preventDefault(); link.focus(); }
          });
        });
        panels.forEach(function (panel) {
          panel.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft') return;
            const rail = Array.prototype.find.call(rails, function (r) { return r.getAttribute('data-pg-mega-cat') === panel.getAttribute('data-pg-mega-panel'); });
            if (rail) { e.preventDefault(); rail.focus(); }
          });
        });
        // Pfeiltasten-Navigation in der Kategorie-Rail (Up/Down/Home/End)
        const railBox = mega.querySelector('.pg-mega__rail');
        if (railBox) {
          railBox.addEventListener('keydown', function (e) {
            if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) === -1) return;
            const list = Array.prototype.slice.call(rails);
            const cur = list.indexOf(document.activeElement);
            if (cur === -1) return;
            e.preventDefault();
            let next = cur;
            if (e.key === 'ArrowDown') next = (cur + 1) % list.length;
            else if (e.key === 'ArrowUp') next = (cur - 1 + list.length) % list.length;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = list.length - 1;
            list[next].focus(); // focus triggert activate() via Listener oben
          });
        }
      });
    });
  }

  function wireLang() {
    document.querySelectorAll('[data-pg-lang]').forEach(function (wrap) {
      once(wrap, 'pgLangWired', function () {
        const toggle = wrap.querySelector('[data-pg-lang-toggle]');
        if (!toggle) return;
        wrap.setAttribute('data-open', 'false');
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = wrap.getAttribute('data-open') === 'true';
          closeAllLangs(wrap);
          wrap.setAttribute('data-open', isOpen ? 'false' : 'true');
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
      });
    });
  }

  // --- Mobile drawer -------------------------------------------------------
  var mmOpener = null;

  function getMobileMenu() {
    return document.querySelector('[data-pg-mobile-menu]');
  }

  function openMobileMenu(opener) {
    const menu = getMobileMenu();
    if (!menu) return;
    closeAllMegas();
    closeAllLangs();
    mmOpener = opener || null;
    menu.hidden = false;
    void menu.offsetHeight; // force reflow so the transition runs
    menu.setAttribute('data-open', 'true');
    document.documentElement.classList.add('pg-mm-lock');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    const closeBtn = menu.querySelector('.pg-mobmenu__close');
    const panel = menu.querySelector('[data-pg-mm-panel]');
    (closeBtn || panel || menu).focus();
  }

  function closeMobileMenu() {
    const menu = getMobileMenu();
    if (!menu || menu.hidden || menu.getAttribute('data-open') !== 'true') return;
    menu.setAttribute('data-open', 'false');
    document.documentElement.classList.remove('pg-mm-lock');
    const panel = menu.querySelector('[data-pg-mm-panel]');
    let done = false;
    function finish() {
      if (done) return;
      done = true;
      if (menu.getAttribute('data-open') !== 'true') menu.hidden = true;
    }
    if (panel) {
      panel.addEventListener('transitionend', function te(e) {
        if (e.target === panel && e.propertyName === 'transform') {
          panel.removeEventListener('transitionend', te);
          finish();
        }
      });
    }
    setTimeout(finish, 520); // fallback (reduced-motion / interrupted transition)
    document.querySelectorAll('[data-pg-burger]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (mmOpener) {
      mmOpener.focus();
      mmOpener = null;
    }
  }

  function trapMobileFocus(e) {
    const menu = getMobileMenu();
    if (!menu || menu.hidden || menu.getAttribute('data-open') !== 'true') return;
    const nodes = menu.querySelectorAll(
      'a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'
    );
    const visible = Array.prototype.filter.call(nodes, function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!visible.length) return;
    const first = visible[0];
    const last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function wireBurger() {
    document.querySelectorAll('[data-pg-burger]').forEach(function (btn) {
      once(btn, 'pgBurgerWired', function () {
        btn.addEventListener('click', function () {
          const menu = getMobileMenu();
          if (menu && menu.getAttribute('data-open') === 'true') {
            closeMobileMenu();
          } else {
            openMobileMenu(btn);
          }
        });
      });
    });

    const menu = getMobileMenu();
    if (!menu) return;
    once(menu, 'pgMmWired', function () {
      menu.querySelectorAll('[data-pg-mm-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeMobileMenu(); });
      });
      // Navigating away should close the drawer (covers same-page anchors too)
      menu.querySelectorAll('a[href]').forEach(function (a) {
        a.addEventListener('click', function () { closeMobileMenu(); });
      });
    });
  }

  function wireResponsiveDrawer() {
    if (!window.matchMedia || document.body.dataset.pgDrawerViewportWired === '1') return;
    document.body.dataset.pgDrawerViewportWired = '1';
    const desktop = window.matchMedia('(min-width: 1101px)');
    const sync = function (event) {
      if (event.matches) closeMobileMenu();
      else { closeAllMegas(); closeAllLangs(); }
    };
    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else if (desktop.addListener) desktop.addListener(sync);
    sync(desktop);
  }

  function wireGlobal() {
    if (document.body.dataset.pgHeaderGlobal === '1') return;
    document.body.dataset.pgHeaderGlobal = '1';

    // Escape closes all menus; Tab traps focus inside the open mobile drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const focused = document.activeElement;
        const megaParent = focused && focused.closest ? focused.closest('[data-pg-mega-parent][data-open="true"]') : null;
        const langParent = focused && focused.closest ? focused.closest('[data-pg-lang][data-open="true"]') : null;
        const returnFocus = megaParent ? megaParent.querySelector('[data-pg-mega-toggle]') : langParent ? langParent.querySelector('[data-pg-lang-toggle]') : null;
        closeAllMegas();
        closeAllLangs();
        closeMobileMenu();
        if (returnFocus) { e.preventDefault(); returnFocus.focus(); }
      } else if (e.key === 'Tab') {
        trapMobileFocus(e);
      }
    });

    document.addEventListener('focusin', function (e) {
      closeAllMegas(e.target.closest('[data-pg-mega-parent]'));
      closeAllLangs(e.target.closest('[data-pg-lang]'));
    });

    // Click outside closes menus
    document.addEventListener('click', function (e) {
      closeAllMegas(e.target.closest('[data-pg-mega-parent]'));
      closeAllLangs(e.target.closest('[data-pg-lang]'));
    });
  }

  // Cart-count/subtotal live update via a lightweight event bus.
  // Any code that hits Shopify's cart AJAX endpoint should dispatch
  //   document.dispatchEvent(new CustomEvent('pg:cart-updated', { detail: { cart, version } }))
  // and the header will refresh in place.
  function formatMoneyCHF(cents) {
    // Fallback CHF formatter: uses shop's Shopify money format if available on window.moneyFormat
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, window.moneyFormat || 'CHF {{amount_with_apostrophe_separator}}');
      } catch (_) {}
    }
    const value = (cents / 100).toFixed(2);
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return 'CHF ' + parts.join('.');
  }

  // the cart pill gives a short nod when something was added (03.10.2026)
  let lastCartCount = null;
  function nodCart(count) {
    const grew = lastCartCount !== null && count > lastCartCount;
    lastCartCount = count;
    if (!grew || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    document.querySelectorAll('[data-pg-cart-link]').forEach(function (link) {
      if (typeof link.animate !== 'function') return;
      try {
        link.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }],
          { duration: 360, easing: 'cubic-bezier(.23,1,.32,1)' });
      } catch (_) {}
    });
  }

  function updateHeaderCart(cart) {
    const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    nodCart(count);
    const total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    document.querySelectorAll('[data-pg-cart-count]').forEach(function (el) { el.textContent = String(count); });
    document.querySelectorAll('[data-pg-cart-total]').forEach(function (el) { el.textContent = formatMoneyCHF(total); });
    document.querySelectorAll('[data-pg-cart-link]').forEach(function (link) {
      link.classList.toggle('pg-cart-pill__empty', count === 0);
    });
  }

  let latestCartVersion = 0;
  document.addEventListener('pg:cart-updated', function (e) {
    const detail = e.detail || {};
    const cart = detail.cart || detail;
    const version = Number(detail.version) || 0;
    if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number' || typeof cart.total_price !== 'number') return;
    if (!version && latestCartVersion) return;
    if (version && version < latestCartVersion) return;
    if (version) latestCartVersion = version;
    updateHeaderCart(cart);
  });

  function wireAll() {
    wireMega();
    wireMegaRail();
    wireLang();
    wireBurger();
    wireResponsiveDrawer();
    wireGlobal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
  document.addEventListener('shopify:section:load', wireAll);
})();
